import { render, staticRenderFns } from "./CompanyOverviewFrontComponent.vue?vue&type=template&id=21150042&"
import script from "./CompanyOverviewFrontComponent.vue?vue&type=script&lang=js&"
export * from "./CompanyOverviewFrontComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports